import React from 'react'; // FIX: Imported React for JSX support
import { FaCheckCircle, FaIdCard, FaTimesCircle } from 'react-icons/fa';

// FIX: Added Interface using ReactNode for the icons
export interface ADStatusUI {
    label: string;
    color: string;
    textColor: string;
    border: string;
    icon: React.ReactNode;
    tooltip: string;
}

// FIX: Applied the ADStatusUI return type
export const getADStatusUI = (isAdUser?: number, accountEnabled?: boolean): ADStatusUI => {
    if (isAdUser === 1 && accountEnabled === true) {
        return {
            label: "Active AD User",
            color: "#d1e7dd", textColor: "#0f5132", border: "#badbcc",
            icon: <FaCheckCircle size={12} />,
            tooltip: "Verified Active Directory user. Their AD account is active."
        };
    } else if (isAdUser === 1 && accountEnabled === false) {
        return {
            label: "Inactive AD User",
            color: "#f8d7da", textColor: "#842029", border: "#f5c2c7",
            icon: <FaTimesCircle size={12} />,
            tooltip: "Verified Active Directory user, but their AD account is currently disabled."
        };
    } else {
        return {
            label: "Not AD User",
            color: "#e2e3e5", textColor: "#41464b", border: "#d3d6d8",
            icon: <FaIdCard size={12} />,
            tooltip: "Local user or imported from an old system. Not linked to Active Directory."
        };
    }
};
